import React from 'react'
import Image from 'next/image'
import { cn } from '@/utilities/ui'

const LOGOS: Record<string, { alt: string; width: number; height: number; className: string }> = {
  '/assets-rebrand/logos/civo-public-black.svg': { alt: 'Civo Public', width: 2826, height: 666, className: 'h-7' },
  '/assets-rebrand/logos/civo-private-black.svg': { alt: 'Civo Private', width: 3092, height: 666, className: 'h-7' },
  '/assets-rebrand/logos/civo-ai-black.svg': { alt: 'Civo AI', width: 1646, height: 505, className: 'h-[21px]' },
  '/assets-rebrand/logos/konstruct-by-civo-logo-black.svg': { alt: 'Konstruct by Civo', width: 1677, height: 295, className: 'h-5' },
}

interface SubHeadingProps {
  text?: string
  logo?: string
  className?: string
  lineClassName?: string
  // 'h2' only when the label is the section's sole heading.
  headingLevel?: 'h2' | 'p'
}

export const SubHeading: React.FC<SubHeadingProps> = ({ text, logo, className, lineClassName = 'border-civo-cloud', headingLevel = 'p' }) => {
  const renderHeading = () => {
    switch (headingLevel) {
      case 'h2':
        return <h2 className="leading-5">{text}</h2>
      case 'p':
      default:
        return <p className="mb-0 leading-5">{text}</p>
    }
  }

  const renderContent = () => {
    if (logo) {
      const size = LOGOS[logo] ?? { alt: '', width: 2826, height: 666, className: 'h-7' }
      return (
        <div className="relative shrink-0">
          <Image
            src={logo}
            alt={size.alt}
            width={size.width}
            height={size.height}
            className={cn('w-auto', size.className)}
          />
        </div>
      )
    }

    if (text) {
      return (
        <div className="subheading-xsmall text-civo-black relative shrink-0 w-full">
          {renderHeading()}
        </div>
      )
    }

    return null
  }

  return (
    <div className={cn("content-stretch flex flex-col gap-2 items-start justify-start relative shrink-0 w-full", className)}>
      {renderContent()}
      <div className={cn("h-px relative shrink-0 w-full border-t", lineClassName)} />
    </div>
  )
}